import { ref } from '@vue/reactivity';
import SessionUtil from '@/utils/SessionUtil';
import RouterUtil from '@/utils/RouterUtil';
import { showConfirmDialog, showToast } from 'vant';
import NavBar from '@/view/components/nav-bar/nav-bar.vue';
import Config from '@/config';
import StorageUtil from '@/utils/StorageUtil';
import UserApi from '@/api/user-api';
import OrderApi from '@/api/order-api';
export default {
  name: 'UserCenter',
  computed: {
    Config() {
      return Config;
    }
  },
  components: {
    NavBar
  },
  setup() {
    const title = ref('用户中心');
    const userAvatar = ref(require('@/assets/img/default-avata.png'));
    const userData = ref();
    return {
      title,
      userAvatar,
      userData
    };
  },
  mounted() {
    this.userData = SessionUtil.getUserData();
    this.getUserData();
  },
  methods: {
    StorageUtil() {
      return StorageUtil;
    },
    goOrders() {
      RouterUtil.go('/order/list');
    },
    goProgress() {
      if (!SessionUtil.isLogin()) {
        return;
      }
      const that = this;
      OrderApi.getProgressOrder().then(function (response) {
        const rs = response.response.data;
        if (response.success) {
          StorageUtil.setObject('orderData', rs.result[0]);
          RouterUtil.go('/order/progress', false, that.$route.path);
        } else {
          OrderApi.getWaitDispatchOrder().then(function (response) {
            const rs = response.response.data;
            if (response.success) {
              RouterUtil.go('/order/calling', false, that.$route.path);
            } else {
              showToast('没有正在进行的行程');
            }
          }).catch(function (error) {
            showToast('没有正在进行的行程');
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    async getUserData() {
      if (!SessionUtil.isLogin()) {
        return;
      }
      const that = this;
      await UserApi.getUserInfo();
      // axios.post(Config.api + '/customer/c_getCustomerInfo.gson', null, {
      //   params: {
      //     customerId: SessionUtil.getUserData("id"),
      //   }
      // }).then(function (response) {
      //   const rs = response.data;
      //   // console.log(response);
      //   if (rs.success) {
      //   }
      // }).catch(function (error) {
      //   console.log(error);
      // });
    },
    goWaitPay() {
      RouterUtil.go('/order/list?waitPay', false, this.$route.path);
    },
    goWaitEvaluate() {
      RouterUtil.go('/order/list?waitEvaluate', false, this.$route.path);
    },
    goVoice() {
      RouterUtil.go('/order/list?voice', false, this.$route.path);
    },
    goSetting() {
      RouterUtil.go('/setting', false, this.$route.path);
    },
    goVIP() {
      RouterUtil.go('/vip', false, this.$route.path);
    },
    logout() {
      showConfirmDialog({
        title: '退出登录',
        message: '确定要退出登录吗？',
        confirmButtonText: '退出'
      }).then(() => {
        SessionUtil.clear();
        RouterUtil.home();
      }).catch(() => {
        // on cancel
      });
    }
  }
};